import React from 'react';
import { ISelectOption } from '../../../domain/saved-filters/interface';
import { BaseFilterCheckboxSelect } from '../base/BaseFilterCheckboxSelect';

interface INominationRecencyFilterSelectProps {
    value: string[];
    onChange: (value: string[]) => void;
    label?: string;
    height?: number;
    searchable?: boolean;
    disabled?: boolean;
    resizable?: boolean;
    options: ISelectOption<string>[];
}

export const NominationRecencyFilterSelect: React.FC<INominationRecencyFilterSelectProps> = ({
    value,
    onChange,
    label,
    height = 120,
    disabled = false,
    options,
}) => {
    return (
        <BaseFilterCheckboxSelect
            multiple
            resizable
            loading={false}
            searchable={false}
            showSelectAllOption={false}
            selectedCountInLabel
            disabled={disabled}
            options={options}
            value={value}
            onChange={onChange}
            label={label}
            height={height}
        />
    );
};
